module.exports = __webpack_public_path__ + "static/media/23.ebb0726d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/23.png
// module id = 1129
// module chunks = 0